const brand = {
    black: '#191919',
    white: '#FEFFFF',
    primary: {
        grey: {
            dark: '#3B4044',
            base: '#949494',
            light: '#F1F1F1',
            lightAlt: '#F1F3F8',
        },
        blue: { base: '#01346B', light: '#7185BE', highlight: '#3CB5AB', steel: '#227C9D' },
    },
    grey: {
        grey13: '#212121',
        grey20: '#333333',
        grey35: '#595959',
        grey40: '#666666',
        grey44: '#707070',
        grey60: '#999999',
        grey76: '#C2C2C2',
        grey80: '#CCCCCC',
        grey90: '#E5E5E5',
        grey97: '#F7F7F7',
    },
    validation: {
        invalid: '#DA291C',
    },
};
export default brand;
export function colourWithTransparency(hexValue, value) {
    const hex = hexValue.replace('#', '');
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    const rgbValue = `${r}, ${g}, ${b}`;
    return `rgba(${rgbValue}, ${value})`;
}
